import { render, staticRenderFns } from "./MobileBuildDock.vue?vue&type=template&id=240c2eac&"
import script from "./MobileBuildDock.vue?vue&type=script&lang=js&"
export * from "./MobileBuildDock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports